<div class="phone-input-container">
  <!-- Selector de país con búsqueda -->
  <div class="phone-input-field">
    <ui-atom-country-select
      [placeholder]="'Select country'"
      [showDialCode]="true"
      [countries]="countries"
      [required]="true"
      [(ngModel)]="selectedCountryCode"
      (ngModelChange)="onCountryChange($event)"
      class="phone-input-country-select"
    >
    </ui-atom-country-select>
  </div>

  <!-- Input de número de teléfono -->
  <div class="phone-input-field">
    <ui-molecule-input
      #phoneInput
      textId="phoneNumber"
      type="tel"
      [placeholder]="'Phone number'"
      [(ngModel)]="phoneNumber"
      (ngModelChange)="onPhoneNumberChange($event)"
      [required]="required"
      class="phone-input-number"
    >
    </ui-molecule-input>
  </div>
</div>
